import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

const AuthenticationContent = ({
    bodyVariables,
    bodyVariableEntries,
    codeExp,
    setCodeExp,
    onSecurityRecommendationChange,
    onExpiryTimeChange,
    securityRecommendation = true,
    showExpiryTime = true,
    onVariableEntryChange,
}) => {
    const [localSecurityRecommendation, setLocalSecurityRecommendation] = useState(securityRecommendation);
    const [localShowExpiryTime, setLocalShowExpiryTime] = useState(showExpiryTime);

    useEffect(() => {
        setLocalSecurityRecommendation(securityRecommendation);
    }, [securityRecommendation]);

    useEffect(() => {
        setLocalShowExpiryTime(showExpiryTime);
    }, [showExpiryTime]);

    const handleSecurityRecommendationChange = (checked) => {
        setLocalSecurityRecommendation(checked);
        onSecurityRecommendationChange(checked);
    };

    const handleExpiryTimeChange = (checked) => {
        setLocalShowExpiryTime(checked);
        onExpiryTimeChange(checked);
    };

    return (
        <div className="authentication-content">
            <div className="auth-content-header">
                <div className="content-title">Content</div>
                <div className="content-description">
                    Content for authentication message templates can't be edited. You can add additional content from the options below.
                </div>
            </div>

            <div className="auth-option-container">
                <Form.Check
                    type="checkbox"
                    id="security-recommendation-checkbox"
                    checked={localSecurityRecommendation}
                    onChange={(e) => handleSecurityRecommendationChange(e.target.checked)}
                />
                <div className="auth-option-content">
                    <div className="auth-option-text">Add security recommendation</div>
                </div>
            </div>

            <div className="auth-option-container">
                <Form.Check
                    type="checkbox"
                    id="expiry-time-checkbox"
                    checked={localShowExpiryTime}
                    onChange={(e) => handleExpiryTimeChange(e.target.checked)}
                />
                <div className="auth-option-content">
                    <div className="auth-option-text">Add expiry time for the code</div>
                    <div className="auth-option-description">
                        After the code has expired, the auto-fill button will be disabled.
                    </div>
                </div>
            </div>

            {localShowExpiryTime && (
                <div className="auth-expiry-input">
                    <Form.Group>
                        <Form.Label>Expires in</Form.Label>
                        <div className="expiry-input-container">
                            <Form.Control
                                type="number"
                                value={codeExp}
                                onChange={(e) => setCodeExp(parseInt(e.target.value) || 1)}
                                min={1}
                                max={60}
                            />
                            <span className="minutes-label">minutes</span>
                            <div className="expiry-input-arrows">
                                <i className="fas fa-chevron-up" onClick={() => setCodeExp(Math.min(60, (codeExp || 0) + 1))}></i>
                                <i className="fas fa-chevron-down" onClick={() => setCodeExp(Math.max(1, (codeExp || 0) - 1))}></i>
                            </div>
                        </div>
                    </Form.Group>
                </div>
            )}

            {bodyVariables && bodyVariables.length > 0 && (
                <div className="variables-section mt-3">
                    <h6>Example Value</h6>
                    <div className="d-flex align-items-center gap-2">
                        <span className="variable-label">{'{{1}}'}</span>
                        <Form.Control
                            type="text"
                            value={bodyVariableEntries[0] || ''}
                            onChange={(e) => onVariableEntryChange(0, e.target.value)}
                            placeholder="Enter verification code example (e.g., 123456)"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

AuthenticationContent.propTypes = {
    bodyVariables: PropTypes.array.isRequired,
    bodyVariableEntries: PropTypes.array.isRequired,
    codeExp: PropTypes.number,
    setCodeExp: PropTypes.func.isRequired,
    onAddVariable: PropTypes.func.isRequired,
    onRemoveVariable: PropTypes.func.isRequired,
    onVariableEntryChange: PropTypes.func.isRequired,
    onSecurityRecommendationChange: PropTypes.func,
    onExpiryTimeChange: PropTypes.func,
    securityRecommendation: PropTypes.bool,
    showExpiryTime: PropTypes.bool,
};

export default AuthenticationContent; 